import MainLayout from "components/templates/MainLayout"

import { Flex, Box } from "@chakra-ui/react"

import CompanyBranches from "components/shared/CompanyBranches"
import Searchbar from "components/UI/molecules/Searchbar"
import TransactionsTable from "./TransactionsTable"
import { useTransactionsContext } from "providers/TransactionsProvider/TransactionsProvider"


const TransactionsTemplate = () => {
  const { searchValue, handleSearchChange } = useTransactionsContext()

  return (
    <MainLayout navigation>
      <Flex
          width={"100%"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <CompanyBranches />
          <Searchbar
            value={searchValue}
            onChange={handleSearchChange}
          />
        </Flex>
        <Box mt="20px">
          <TransactionsTable />
        </Box>
    </MainLayout>
  )
}

export default TransactionsTemplate